var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    key: 'preference' + _vm.key,
    attrs: {
      "margin": 0,
      "flat": "",
      "outlined": "",
      "subtitle": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.registration.registrationName.title'),
      "hideTitle": true
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [!_vm.isRegistrationName ? _c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("add")) + " ")]) : _vm._e(), _vm.showRemove ? _c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": _vm.remove
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]) : _vm._e()];
      },
      proxy: true
    }])
  }, [_vm.isRegistrationName ? _c('div', {
    staticClass: "pt-2 pr-2 pl-2"
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pr-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.registration.registrationName.firstName')
    },
    model: {
      value: _vm.reportDto.registrationResults.firstname,
      callback: function callback($$v) {
        _vm.$set(_vm.reportDto.registrationResults, "firstname", $$v);
      },
      expression: "reportDto.registrationResults.firstname"
    }
  })], 1), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.registration.registrationName.lastName')
    },
    model: {
      value: _vm.reportDto.registrationResults.name,
      callback: function callback($$v) {
        _vm.$set(_vm.reportDto.registrationResults, "name", $$v);
      },
      expression: "reportDto.registrationResults.name"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }